import { ImprUserDropdown } from '@imprivata-cloud/components';
import { Layout } from 'antd';
import { useEffect, type PropsWithChildren } from 'react';
import { useLocalLogout, useLogout } from '../../portal/hooks/useLogout';
import { useIdleTimeout } from '../../portal/hooks/useIdleTimeout';
import { SELF_SERVICE_TIMEOUT } from '../../portal/constants';
import ImprivataLogo from '../../assets/Imprivata_Logo.svg?react';
import './SelfServiceLayout.less';

const { Header, Content, Footer } = Layout;

export interface SelfServiceLayoutProps {
  username: string;
  email: string;
  logoUrl: string;
}

const SelfServiceLayout = ({ children, username, logoUrl, email }: PropsWithChildren<SelfServiceLayoutProps>) => {
  const hasLogoUrl = logoUrl !== '';
  const handleLocalLogout = useLocalLogout();
  const handleLogout = useLogout();
  const { startIdleTimer, stopIdleTimer } = useIdleTimeout(SELF_SERVICE_TIMEOUT, handleLocalLogout);

  useEffect(() => {
    startIdleTimer();
    return () => {
      stopIdleTimer();
    };
  }, [startIdleTimer, stopIdleTimer]);

  return (
    <div className="self-service-page">
      <Layout className="self-service-layout">
        <Header className="self-service-header">
          <div className="header-content">
            <ImprUserDropdown username={username} email={email} onLogout={handleLogout} />
            {hasLogoUrl && <img src={logoUrl} alt="logo" />}
          </div>
        </Header>

        <Layout className="content-layout">
          <Content className="self-service-content">{children}</Content>
        </Layout>

        <Footer className="self-service-footer">
          <ImprivataLogo />
          <div className="footer-right">Imprivata Self-service</div>
        </Footer>
      </Layout>
    </div>
  );
};

export default SelfServiceLayout;
